<template>
  <div
    class="col-12"
  >
    <div class="card card--profile-tasks">
      <div
        v-b-toggle="`collapseOtherNotifications`"
        class="card-header"
      >
        <h3 class="float-start"> Other notifications <span
          v-if="!loading"
          class="badge bg-light-info"
        >{{ items.length }}</span>
        </h3>
        <div class="heading-elements heading-elements-custom">
          <div class="btn-group dropdown-icon-wrapper d-none d-sm-block disp-in">
            <b-dropdown
              class="btn btn-secondary btn-sm"
              toggle-class="p-0"
              @click="$event.stopPropagation()"
            >
              <template #button-content>
                Multiple actions
              </template>
              <b-dropdown-item @click="archive">
                <i
                  class="me-50"
                  data-feather="archive"
                /> Archive
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <ul class="list-inline mb-0 disp-in ms-2">
            <li>
              <a data-action="collapse"><svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-down"
              ><polyline points="6 9 12 15 18 9" /></svg></a>
            </li>
          </ul>
        </div>
      </div>
      <b-collapse
        :id="`collapseOtherNotifications`"
        :visible="!fields.find(e => e.name == 'Other notifications') || fields.find(e => e.name == 'Other notifications').visibility"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="table-responsive"
          >
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th
                    class="cursor-pointer"
                  >
                    <input
                      v-model="clicked"
                      type="checkbox"
                      @click="selectAll($event)"
                    >
                  </th>
                  <th>User</th>
                  <th>Date entry</th>
                  <th>Title</th>
                  <th class="text-end">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>
                    <input
                      :checked="
                        clicked
                      "
                      type="checkbox"
                      @click="select($event.target.checked, item)"
                    >
                  </td>
                  <td>{{ item.user.name }}</td>
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.title }}</td>
                  <td class="text-end">
                    <a
                      @click="$emit('showAlert', item)"
                    >
                      <i data-feather="eye" />
                    </a>
                    <a
                      v-if="item.targetable_url && item.targetable"
                      class="ms-1"
                      :href="$router.resolve({name: item.targetable_url, params: {id: item.targetable.id} , query: { actAs: $route.query.actAs } }).href"
                      target="_target"
                    >
                      <i data-feather="external-link" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BCollapse } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCollapse,
  },
  data() {
    return {
      userId: this.$route.params.id,
      loading: false,
      selectedItems: [],
      clicked: false,
    }
  },
  computed: {
    ...mapGetters({
      items: 'alerts/others',
      fields: 'modals/tableSettingsFields',
      loggedUser: 'auth/admin',
    }),
  },
  async mounted() {
    await this.$store.dispatch('alerts/fetchOtherNotifications')
    feather.replace({
      width: 14,
      height: 14,
    })
  },
  methods: {
    async archive(event) {
      event.stopPropagation()
      const promises = this.selectedItems.map(val => this.$store.dispatch('alerts/archive', val.id))
      await Promise.all(promises)

      this.loading = true
      await this.$store.dispatch('alerts/fetchOtherNotifications')
      this.loading = false
    },
    selectAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.items
      } else {
        this.selectedItems = []
      }
    },
    select(click, item) {
      if (click) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(this.selectedItems.findIndex(x => x.id === item.id), 1)
      }
    },
  },
}
</script>
